module.exports = __webpack_public_path__ + "img/Ad_4.5310583a.jpg";